import type { VoidFunctionComponent } from 'react';

import AbandonwareDescription from './AbandonwareDescription';
import NativeCodeDescription from './NativeCodeDescription';

import { RISK_ISSUE_TYPE, type RiskIssueType } from '../../../../../shared/issuesV2';

type RiskDescriptionProps = {
  type: RiskIssueType;
  locator: string;
};

/**
 * Container component for displaying Risk issue details. Risk issues require some extra async data fetches, which is why
 * they're split out into their own component.
 */
const RiskDescription: VoidFunctionComponent<RiskDescriptionProps> = ({
  locator,
  type,
}) => {
  switch (type) {
    case RISK_ISSUE_TYPE.RiskAbandonware: {
      return <AbandonwareDescription locator={locator} />;
    }
    case RISK_ISSUE_TYPE.RiskEmptyPackage: {
      return (
        <div>
          No reasonable source files were found inside of the package.
        </div>
      );
    }
    case RISK_ISSUE_TYPE.RiskNativeCode: {
      return <NativeCodeDescription locator={locator} />;
    }
    default: {
      return (
        <div>
          Unknown risk type.
        </div>
      );
    }
  }
};

export default RiskDescription;
